import { render, staticRenderFns } from "./CreateMoney.vue?vue&type=template&id=3c90526c&scoped=true"
import script from "./CreateMoney.vue?vue&type=script&lang=js"
export * from "./CreateMoney.vue?vue&type=script&lang=js"
import style0 from "./CreateMoney.vue?vue&type=style&index=0&id=3c90526c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c90526c",
  null
  
)

export default component.exports